// Whether the boards are shown as tabs (Features 7), and how (Features 8: an island or a bar, icons). Both are kept with the
// account, and the last of each is kept on this device too, so a reload draws the bar it will end up with from the
// first paint, before the account has answered.

import { useEffect } from "react";
import { readStored, readStoredJson, writeStored, writeStoredJson } from "../lib/stored";
import { useStore } from "../state/store";

const KEY = "cb:tabs";
// the look as it is since 1 Nov, the island the default (the key before held floating as the exception)
const LOOK = "cb:tabs:look2";

export function useTabsOn(): boolean {
  const known = useStore((s) => (s.workspace ? !!s.workspace.boardTabs : null));
  useEffect(() => {
    if (known !== null) writeStored(KEY, known ? "1" : "0");
  }, [known]);
  return known ?? readStored(KEY) === "1";
}

/** The tabs' look: a bar across the top instead of the island where the pill sits, and the boards' icons on them or not. */
export function useTabLook(): { bar: boolean; icons: boolean } {
  const known = useStore((s) => (s.workspace ? `${s.workspace.tabLook?.bar ? 1 : 0}${s.workspace.tabLook?.noIcons ? 0 : 1}` : null));
  useEffect(() => {
    if (known !== null) writeStoredJson(LOOK, known);
  }, [known]);
  const kept = readStoredJson<unknown>(LOOK, "01");
  const look = known ?? (typeof kept === "string" && kept.length === 2 ? kept : "01");
  return { bar: look[0] === "1", icons: look[1] !== "0" };
}
